import React, { useCallback, useMemo, useEffect } from 'react';
import { Dialog, Autocomplete } from '@sravni/react-design-system';
import { Search } from '@sravni/react-icons';
import { useStyles, useDebounceValue, useFetch } from '@sravni/react-utils';
import { setRegionCookie } from '../helpers/index.js';
import modules_e5ab2127 from '../styles/RegionDialog.module.less.js';
import RegionsList from './RegionsList.js';

/**
 * @description RegionDialog component.
 *
 * @component
 * @example
 * ```jsx
 * <RegionDialog />
 * ```
 */
const RegionDialog = React.forwardRef((props, ref) => {
    const { title = 'Выберите город', subtitle, icon, onChange, onClose, className, ...restProps } = props;
    const cx = useStyles(modules_e5ab2127);
    const [searchValue, setSearchValue] = React.useState(undefined);
    const debounceSearchValue = useDebounceValue(searchValue, 500);
    const [{ get, data, loading }] = useFetch(new URL('/suggest/v2/locations/', "https://api.sravni.ru").toString());
    const handleChangeInput = useCallback((value) => {
        setSearchValue(value);
    }, []);
    const handleSelect = useCallback((region) => {
        setRegionCookie("_SLv2_", region.routeGar);
        // @TODO: Установка старой куки на время переезда на новые локации
        if (region.route)
            setRegionCookie("_SL_", region.route);
        onChange?.(region);
    }, [onChange]);
    const handleChangeSelect = useCallback((selectedGarId) => {
        if (!data) {
            return;
        }
        const region = data.find((o) => o.garId === selectedGarId);
        if (region) {
            setRegionCookie("_SLv2_", region.routeGar);
            // @TODO: Установка старой куки на время переезда на новые локации
            if (region.route)
                setRegionCookie("_SL_", region.route);
            onChange?.(region);
        }
    }, [data, onChange]);
    const options = useMemo(() => {
        if (!data) {
            return [];
        }
        return data.map((item) => ({ label: item.name, value: item.garId }));
    }, [data]);
    useEffect(() => {
        if (debounceSearchValue) {
            get({ q: debounceSearchValue, excludeNewRegions: 'true' });
        }
    }, [debounceSearchValue, get]);
    return (React.createElement(Dialog, { ref: ref, onClose: onClose, ...restProps },
        React.createElement(Dialog.Header, { icon: icon, title: title, subtitle: subtitle }),
        React.createElement(Dialog.Content, { className: cx('content') },
            React.createElement("div", { className: cx(className, 'container') },
                React.createElement(Autocomplete, { placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u043E\u0440\u043E\u0434\u0430", loading: loading, options: options, onSearch: handleChangeInput, onSelect: handleChangeSelect, icon: React.createElement(Search, null) }),
                React.createElement(RegionsList, { onSelect: handleSelect })))));
});
RegionsList.displayName = 'RegionDialog';

export { RegionDialog };
//# sourceMappingURL=RegionDialog.js.map
